import { render, staticRenderFns } from "./crud-table.vue?vue&type=template&id=a5570d52&scoped=true"
import script from "./crud-table.vue?vue&type=script&lang=js"
export * from "./crud-table.vue?vue&type=script&lang=js"
import style0 from "./crud-table.vue?vue&type=style&index=0&id=a5570d52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5570d52",
  null
  
)

export default component.exports